<template>
   <svg viewBox="0 0 14 14">
      <path
         fill="currentColor"
         fill-rule="evenodd"
         d="M7 .38c3.614-.003 6.627 3.016 6.627 6.623c0 3.61-3.013 6.62-6.627 6.618a6.64 6.64 0 0 1-2.753-.596l-3.28.593a.5.5 0 0 1-.558-.668l.94-2.498a6.643 6.643 0 0 1-.97-3.45C.38 3.395 3.39.382 7 .38Zm3.325 9.436c-.737.596-1.878 1.198-2.969.498c-1.43-.919-2.696-2.126-3.614-3.557c-.539-.838-.032-2.18.726-2.998c.302-.327.8-.275 1.129.025l.692.632c.21.192.218.526.087.78c-.207.398-.329.933-.073 1.332c.322.5.718.993 1.664 1.28c.286.088.653.05.965-.076c.261-.106.592-.105.785.101l.644.685c.355.378.367.972-.036 1.298Z"
         clip-rule="evenodd" />
   </svg>
</template>
